/* eslint-disable */
import React, { useEffect, useState } from 'react'
import AOS from 'aos'
import FeaturesModal from '../modal/FeaturesModal'
import { features } from './data'

export default function Features() {
  const [show, setshow] = useState(false)
  const [modalData, setModalData] = useState([])

  const getModalData = (a, b, c, d, e, f, g, h, i) => {
    let modalData = [a, b, c, d, e, f, g, h, i]
    setModalData((item) => [1, ...modalData])

    return setshow(true)
  }

  useEffect(() => {
    AOS.init({ once: true })
  }, [])
  const [showModal, setShowModal] = useState(false)

  const closeModal = () => {
    setShowModal(!showModal)
  }
  return (
    <div className='py-8 sm:py-12 md:py-16 bg-white'>
      <FeaturesModal
        isOpen={show}
        setIsOpen={setshow}
        title={modalData[1]}
        featureTitle={modalData[2]}
        featureText1={modalData[3]}
        featureTitle2={modalData[4]}
        featureText2={modalData[5]}
        featureTitle3={modalData[6]}
        featureText3={modalData[7]}
        featureTitle4={modalData[8]}
        featureText4={modalData[9]}
      />
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='text-center'>
          <h2 className='text-center mt-2 text-3xl md:text-5xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl'>
            Passengers Delight
          </h2>
          <p className='mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto'>
              Below are just a few of the many advantages of choosing Oya! as your travelling partner
          </p>
        </div>

        <div className='mt-10'>
          <dl className='space-y-10 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10'>
            {features.map((feature, index) => (
              <div
                key={feature.name}
                className='relative text-lg'
                data-aos='fade-up'
                data-aos-delay={`${index > 0 ? 200 * index : 0}`}
                data-aos-duration='1000'
              >
                <dt>
                  <div className='absolute flex items-center justify-center h-12 w-12 rounded-md bg-oya-ghana-green text-white'>
                    <feature.icon className='h-6 w-6' aria-hidden='true' />
                  </div>
                  <p className='font-bold ml-16 text-lg leading-6 text-gray-900'>
                    {feature.name}
                  </p>
                </dt>
                <dd className='font-medium mt-2 ml-16 text-base text-black'>
                  {feature.description}
                  <button
                    className='text-oya-ghana-green font-bold'
                    onClick={() =>
                      getModalData(
                        feature.detail.title,
                        feature.detail.featureTitle,
                        feature.detail.featureText1,
                        feature.detail.featureTitle2,
                        feature.detail.featureText2,
                        feature.detail.featureTitle3,
                        feature.detail.featureText3,
                        feature.detail.featureTitle4,
                        feature.detail.featureText4
                      )
                    }
                  >
                    Read More
                  </button>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
